import { Dropdown, Grid, Image, Selector } from "antd-mobile";
import { useRef } from "react";
import { useTranslation } from "react-i18next";
import { moneyFormat } from "../../../../../plugins/numberFormat";
import { envChangeType } from "../../../../../plugins/utils";
import { useComission } from "../../context/ComissionContext";
import TitleContainer from "../ComissionBetAmountRebate/components/TitleContainer";
import styles from "./style.module.scss";
import "./style.scss";
const ComissionDataHybrid = () => {
  const { t } = useTranslation();
  const {
    months,
    selectedMonth,
    setSelectedMonth,
    weeks,
    selectedWeek,
    setSelectedWeek,
    comissionHeader,
    isHeaderError,
    isHeaderLoading,
  } = useComission();
  const dropDownRef = useRef();

  const onSelectMonthChange = (value) => {
    if (value.length > 0) {
      const _month = months.find((month) => month.value === value[0]);
      setSelectedMonth(_month);
      dropDownRef.current.close();
    }
  };

  const onSelectWeekChange = (value) => {
    if (value.length > 0) {
      const _week = weeks.find((week) => week.value === value[0]);
      console.log("_week", _week);
      setSelectedWeek(_week);
      dropDownRef.current.close();
    }
  };

  const comissionList = [
    {
      title: t("comission.calculation.winloss"),
      valueKey: "calculated_loss_amount",
      type: "content",
      symbol: "+",
    },
    {
      title: t("comission.calculation.platform"),
      valueKey: "total_game_3th_fee",
      type: "content",
      symbol: "-",
    },
    {
      title: t("comission.calculation.comission"),
      valueKey: "basic_bonus_amount",
      type: "footer",
      symbol: "+",
    },
  ];

  return (
    <div className={`${styles.container} winloss-container`} id="winloss-container">
      <div className={styles.header}>
        <div className={styles.contentShadow}>
          <div
            className={styles.title2}
            dangerouslySetInnerHTML={{ __html: t("comission.winloss.title.1") }}
          />
        </div>
        <div className={styles.content}>
          <div
            className={styles.title2}
            dangerouslySetInnerHTML={{ __html: t("comission.winloss.title.1") }}
          />
        </div>
        <Image
          className={styles.background}
          src={`/images/comission/${envChangeType("REACT_APP_PRODUCTION_NAME_DEV")}/winlose-header.png`}
          fallback={
            <Image
              src={`/images/comission/default/winlose-header.png`}
              className={styles.background}
              placeholder={false}
            />
          }
        />
      </div>
      <div className={styles.card}>
        <TitleContainer title={t("comission.winlose.ruledesc.title")} />
        <div className={styles.contentDesc}>
          <Image
            width={103}
            src={`/images/comission/${envChangeType("REACT_APP_PRODUCTION_NAME_DEV")}/winlose-avatar.png`}
            fallback={
              <Image
                width={103}
                className={styles.img}
                src={`/images/comission/default/winlose-avatar.png`}
                placeholder={false}
              />
            }
          />
          <div className={styles.content}>{t("comission.winlose.ruledesc.1")}</div>
        </div>
      </div>
      <TitleContainer title={t("comission.calculation.comission")} />
      <div className={styles.comissionDescContainer}>
        <Dropdown
          getContainer={() => document.getElementById("winloss-container") || document.body}
          ref={dropDownRef}
          style={{ width: "100%" }}
        >
          <Dropdown.Item key={"week"} className={"custom-dropdown"} title={selectedWeek?.label}>
            <div className={`comission-report-filter-select`}>
              <Selector
                className={"custom-selector"}
                options={weeks}
                columns={2}
                value={selectedWeek?.value}
                onChange={onSelectWeekChange}
              />
            </div>
          </Dropdown.Item>
        </Dropdown>
        {isHeaderLoading ? null : isHeaderError ? null : (
          <>
            <div className={`${styles.card} ${styles.noPadding}`}>
              {comissionList.map((comission, index) => {
                return (
                  <>
                    <div
                      className={`${styles.listRow} ${
                        comission.type === "footer" ? styles.footer : ""
                      }`}
                    >
                      <div className={styles.title}>{comission.title}</div>
                      <div className={styles.contentContainer}>
                        <div className={styles.title}>
                          {comission.type === "footer" ? "=" : "+"}
                        </div>
                        <div className={styles.content}>
                          {`${
                            comission.symbol === "-" &&
                            comissionHeader?.data[comission.valueKey] > 0
                              ? "-"
                              : ""
                          } ${moneyFormat(comissionHeader?.data[comission.valueKey])}`}
                        </div>
                      </div>
                    </div>
                  </>
                );
              })}
            </div>
          </>
        )}
        <div className={`${styles.card} ${styles.noPadding} ${styles.summary}`}>
          <Grid columns={2} gap={0}>
            <Grid.Item>
              <div className={styles.menu}>
                <div className={styles.overviewContent}>{`${
                  comissionHeader?.data?.win_loss_bonus_rate || 0
                }%`}</div>
                <div className={styles.overviewTitle}>
                  <div className={styles.title}>{t(`mobile.comission.ratio.winloss`)}</div>
                </div>
              </div>
            </Grid.Item>
            <Grid.Item>
              <div className={styles.menu}>
                <div className={styles.overviewContent}>{`${
                  comissionHeader?.data?.add_agent_bonus_rate || 0
                }%`}</div>
                <div className={styles.overviewTitle}>
                  <div className={styles.title}>{t(`mobile.comission.ratio.agentBonus`)}</div>
                </div>
              </div>
            </Grid.Item>
          </Grid>
        </div>
      </div>
      {/* <Dropdown ref={dropDownRef}>
        <Dropdown.Item key={"week"} className={"custom-dropdown"} title={selectedWeek?.label}>
          <div className={`comission-report-filter-select`}>
            <Selector
              className={"custom-selector"}
              options={weeks}
              columns={2}
              value={selectedWeek?.value}
              onChange={onSelectWeekChange}
            />
          </div>
        </Dropdown.Item>
      </Dropdown>
      {isHeaderLoading ? null : isHeaderError ? null : (
        <>
          <HomeCard title={t("comission.calculation.comission")}>
            {comissionList.map((comission, index) => {
              return (
                <>
                  <div
                    className={`${styles.listRow} ${
                      comission.type === "footer" ? styles.footer : ""
                    }`}
                  >
                    <div className={styles.title}>{comission.title}</div>
                    <div className={styles.content}>
                      {`${
                        comission.symbol === "-" && comissionHeader?.data[comission.valueKey] > 0
                          ? "-"
                          : ""
                      } ${moneyFormat(comissionHeader?.data[comission.valueKey])}`}
                    </div>
                  </div>
                  {index < comissionList.length - 1 ? <Divider className={styles.divider} /> : null}
                </>
              );
            })}
          </HomeCard>
        </>
      )}
      <HomeCard title={t("administrationCenter.overview.commision.title.new")}>
        <Grid columns={2} gap={0}>
          <Grid.Item>
            <div className={styles.menu}>
              <div className={styles.overviewTitle}>
                <div className={styles.title}>{t(`mobile.comission.ratio.winloss`)}</div>
              </div>
              <div className={styles.overviewContent}>{`${
                comissionHeader?.data?.win_loss_bonus_rate || 0
              }%`}</div>
            </div>
          </Grid.Item>
          <Grid.Item>
            <div className={styles.menu}>
              <div className={styles.overviewTitle}>
                <div className={styles.title}>{t(`mobile.comission.ratio.agentBonus`)}</div>
              </div>
              <div className={styles.overviewContent}>{`${
                comissionHeader?.data?.add_agent_bonus_rate || 0
              }%`}</div>
            </div>
          </Grid.Item>
        </Grid>
      </HomeCard> */}
    </div>
  );
};

export default ComissionDataHybrid;
